import React,{useState, useEffect,useCallback} from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle,Button,Grid , CircularProgress, Grow, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import styled from 'styled-components';
import { ExpandMore  } from '@material-ui/icons';
import CriteriaPanel from 'app/list/common/Criteria/CriteriaPanel';
import {  useObserver } from "mobx-react";
import { toJS } from 'mobx';
import { LIMIT_NO_RECORDS } from './DuplicateSheet';

const DuplicateSheetOptions = ({open, handleClose, options, handleCheckboxOnChange, setCurrentPage, isLoading, totalRecordsCount, handleDuplicateBtnClicked, dataRecordOptions, isDuplicateDataChecked, setDataRecordOptions ,currentPack=false}) => {

    const [isDuplicating, setIsDuplicating] = useState(false);
    const duplicateOptionsSubmitHandler = async (e) => {
        if((isDuplicateDataChecked) && (+dataRecordOptions.limit > LIMIT_NO_RECORDS || +dataRecordOptions.limit <= 0 || +dataRecordOptions.limit > totalRecordsCount)){
            const message = +dataRecordOptions.limit > totalRecordsCount ?  `Only a maximum of ${totalRecordsCount} records can be duplicated.`
            : +dataRecordOptions.limit <= 0 ? `The number of records to be duplicated cannot be less than 1` : `Only a maximum of 100k records can be duplicated. Contact support for further assistance.`;
            
            window.appStore.notificationStore.showNotification(
                message, "warning"
                );
            return;
        }

        if(currentPack){
            setIsDuplicating(true);
            await handleDuplicateBtnClicked(e,options, dataRecordOptions);
            setIsDuplicating(false);
        }
        else{
            setCurrentPage(2);
        }
    }

    let {
        list,
        listId,
        view,
    } = useData();

    let viewCriteria = "";
    const [criteria, setCriteria] = useState("");
    const [columnsForCriteriaPanel, setColumnsForCriteriaPanel] = useState([]);

    const handleCriteriaChange = useCallback(
        (criteria) => {
            setCriteria(criteria);
            setDataRecordOptions({target: {name: "", value: ""}}, {isset: true, criteria: criteria});
        },
        [setCriteria]
    );

    
    useEffect(() => {
        TL.list.reports.ColumnsFormatter.getViewColumns(
            list,
            view,
            Ext.bind(function (columns) {
            let currentSheetColumns = TL.list.settings.lookup.CriteriaHelper.formatColumns(
                window.structuredClone(columns),
                {
                listNameStr: list.name,
                }
            );
            let curr = currentSheetColumns.filter((column) => !(column?.column_type_id == "6" || column?.name.includes("=>") || column?.name == "Created By"));
            setColumnsForCriteriaPanel(curr);
            })
        );
    }, [list, view]);



    return (
        <Dialog open={open} onClose={handleClose} fullWidth={true} className='dupOptionsContainer' TransitionComponent={Grow} transitionDuration={1000} maxWidth={isDuplicateDataChecked ?'md':'sm'} >
            <StyledDialogTitle>Select which properties of the current sheet you want to duplicate!</StyledDialogTitle>
            <StyledDialogContent dividers={true} >
                <form onSubmit={duplicateOptionsSubmitHandler} >
                    <StyledDiv >
                        {options.map(option => <IndividualProperty propertyName={option.name} 
                        handleCheckboxOnChange={handleCheckboxOnChange} key={option.id} selected={option.selected} 
                        identity={option.identity} 
                        disabled={option.disabled ?? false} isDuplicating={isDuplicating}/>)}
                        {
                            isDuplicateDataChecked &&
                                <StyledAccordian className='accordian-popup'>
                                    <AccordionSummary
                                        expandIcon={ <ExpandMore/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    > 
                                        <span style={{fontSize: "1rem"}}>
                                            Record Options
                                        </span>
                                    </AccordionSummary>
                                    {isLoading ? 
                                        <CircularProgress className="styled-loader-for-total-records"/> :
                                        <AccordionDetails className='accordian-details-for-duplicate-options' dividers={true}>
                                            <div style={{ padding: "0.3rem 0.6rem"}}>
                                                {
                                                    isDuplicateDataChecked && dataRecordOptions["limit"] > 100000 &&
                                                    <h6 style={{paddingBottom:"10px"}}>Only a maximum of <em>100K</em> records can be duplicated. Contact support for further assistance.</h6>
                                                }
                                                <LimitComponent dataRecordOptions={dataRecordOptions} setDataRecordOptions={setDataRecordOptions} totalRecordsCount={totalRecordsCount} isDuplicating={isDuplicating} />
                                                <OffsetComponent dataRecordOptions={dataRecordOptions} setDataRecordOptions={setDataRecordOptions} isDuplicating={isDuplicating} />
                                                <OffsetComponent dataRecordOptions={dataRecordOptions} setDataRecordOptions={setDataRecordOptions} topOrBottom='bottom' isDuplicating={isDuplicating} />
                                                <StyledHeader6 >Add Criteria  </StyledHeader6>
                                                <DialogContent className='styled-dialog-criteria-panel'>
                                                    <Grid container>
                                                        <CriteriaPanel
                                                            onChange={handleCriteriaChange}
                                                            value={
                                                            typeof viewCriteria === "object"
                                                                ? toJS(viewCriteria)
                                                                : viewCriteria
                                                            }
                                                            lookupColumns={columnsForCriteriaPanel}
                                                            lookupListId={listId}
                                                            currentSheetColumns={columnsForCriteriaPanel}
                                                            currentListId={listId}
                                                            hiddenMultiLevels={false}
                                                            forDuplication = {true}
                                                        />
                                                    </Grid>
                                                </DialogContent>
                                            </div>
                                        </AccordionDetails>
                                    }
                                </StyledAccordian>
                        }           
                    </StyledDiv>
                </form>
            </StyledDialogContent>
            <DialogActions>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={duplicateOptionsSubmitHandler}
                    disabled={isDuplicating}
                    >
                    {isDuplicating ? <DuplicatingLabel /> : "DUPLICATE"}
                </StyledButton>
                <StyledButton
                    onClick={handleClose}
                    variant="outlined"
                    color="primary"
                    disabled={isDuplicating}
                    >
                    CANCEL
                </StyledButton>
            </DialogActions>
        </Dialog>
    )
}

export default DuplicateSheetOptions;

const StyledDialogContent = styled(DialogContent) `
    max-height: 69vh;
    margin-inline: 2rem;
`;


const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    user-select: none;
`;
const StyledHeader6 = styled.h6`
    padding: 0 0.3rem 0.8rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const StyledButton = styled(Button)`
    margin : 0.3rem 1rem;
`;

const StyledDialogTitle = styled(DialogTitle)`
    text-align: center
`;


const StyledAccordian = styled(Accordion)`
    &&{
        width : 100%;
        background-color : #f3f3f3;
        user-select: text;
    }
    `;

const IndividualProperty = ({propertyName,selected,identity,handleCheckboxOnChange,isDuplicating,disabled=false}) => {

    return (
        <div className="individualOption">
            <StyledLabel className="dupLabels" htmlFor={identity}>
                <input
                type="checkbox"
                name={identity}
                id={identity}
                onChange={handleCheckboxOnChange}
                checked={selected}
                disabled={disabled || isDuplicating}
                />
                <span>{propertyName}</span>
            </StyledLabel>
        </div>
        );

}

const LimitComponent = ({dataRecordOptions, setDataRecordOptions, totalRecordsCount, isDuplicating = false}) =>{
    
    return (
        <div style={{marginBottom: "1.3rem"}}>
            <StyledLabel htmlFor='records-limit'>
                <span className='overTheTopLabel'>Limit</span>
                <input
                    required
                    name='limit'
                    type="number" 
                    max={totalRecordsCount} 
                    min={"1"}
                    id='records-limit'
                    value={dataRecordOptions.limit}
                    disabled={isDuplicating}
                    onChange={(e)=>{
                        setDataRecordOptions(e)}} />
            </StyledLabel>
        </div>
    );
}

const OffsetComponent = ({dataRecordOptions, setDataRecordOptions, topOrBottom = "top", isDuplicating = false}) => {

    return (
        <div className='offset-component'>
        <StyledLabel htmlFor={topOrBottom}>
            <input 
                name='direction'
                type="radio" 
                id={topOrBottom}
                checked = {topOrBottom === dataRecordOptions.direction}
                value={topOrBottom}
                disabled={isDuplicating}
                onChange={setDataRecordOptions} />
            <span >Duplicate the <strong>{`${topOrBottom == "top" ? "oldest" : "latest"} ${dataRecordOptions.limit}`}</strong> records</span>
        </StyledLabel>
    </div>
    );
}

const StyledLabel = styled.label`
    display:flex;
    gap: 0.625rem;
    justify-content: flex-start;
    align-items: center;
`;

const DuplicatingLabel = () => {
    return (
        <>
            <CircularProgress size={18} color="white" />
            <span className="ml-duplicating-loader">Duplicating</span>
        </>
        );
}

function useData() {
    const containerStore = window.appStore.containerStore;
    const currentListId = containerStore.listId;
    const listConfig = containerStore.listConfig;
    const currentViewStore = containerStore.getCurrentViewStore();

    return useObserver(() => ({
        list: listConfig.list,
        listId: currentListId,
        view: containerStore.view,
        containerStore: containerStore,
        criteria: currentViewStore?.isCriteriaModified
        ? currentViewStore?.modifiedCriteria
        : containerStore?.view?.criteria,
    }));
}
